import App from 'app/app.js';
import 'app/service/EventService.js';

function LocaleChangeAction(EventService) {
  this.eventName = 'localeChange';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('LocaleChangeAction', ['EventService', LocaleChangeAction]);
